import React, { Component } from 'react'
import { authContext } from '../../Login/AuthContext';

/*  eslint eqeqeq: 0 */

const Checkbox = props => (
  <input type="checkbox" defaultChecked {...props} />
)

export default class Checkboxs extends Component {
  static contextType = authContext;
  state = {
    ventilations : {"nbaccomm":false, "checkin":true, "nights":false, "nbovernights":false}
  }

  componentDidMount = () => {
    if(this.context.auth.data.ventilations)
      this.setState ({ventilations:this.context.auth.data.ventilations});
    else {
      this.context.auth.data.ventilations = this.state.ventilations;
      this.context.setAuthData(this.context.auth.data);
    }
  }

  handleCheckbox = checkedBox => {
    var className = "";
      if(checkedBox.target.id == "accommodation_checkbox")  className = "nbaccomm";
      else if(checkedBox.target.id == "checkin_checkbox")   className = "checkin";
      else if(checkedBox.target.id == "nights_checkbox")    className = "nights";
      else if(checkedBox.target.id == "overnights_checkbox")className = "nbovernights";
      var ventilations = this.state.ventilations;
      ventilations[className] = !ventilations[className];
      this.setState({ventilations:ventilations});
      this.showVentilationTypes(className, ventilations[className]);
      this.context.auth.data.ventilations = ventilations;
      this.context.setAuthData(this.context.auth.data);
  };

  showVentilationTypes (className, state){
    var list = document.getElementsByClassName(className)
    for (var i=0;i<list.length;i++)
      list[i].style.display = (state?"":"none");
  }

  render (){
    return (
      <div>
        <Checkbox id="accommodation_checkbox" onChange={this.handleCheckbox} defaultChecked={this.state.ventilations["nbaccomm"]}/>Hébergements -&nbsp;
        <Checkbox id="checkin_checkbox" onChange={this.handleCheckbox} defaultChecked={this.state.ventilations["checkin"]}/> Réservations B -&nbsp;
        <Checkbox id="nights_checkbox" onChange={this.handleCheckbox} defaultChecked={this.state.ventilations["nights"]}/> Nuits -&nbsp;
        <Checkbox id="overnights_checkbox" onChange={this.handleCheckbox} defaultChecked={this.state.ventilations["nbovernights"]}/> Nuitées estimées
      </div>
    )
  }
}
